import { ALLOCATE_POSITIONS } from 'constants/endpoints';
import { METHOD_POST } from 'requests';
import { ApiRequestConfigType } from 'requests/index.types';

export const API_POST_updateCustomerPositionsAllocation = (
  id: string,
  location_position_ids: number[] | [],
): ApiRequestConfigType => {
  const payload = {
    community: {
      location_position_ids,
    },
  };

  return {
    method: METHOD_POST,
    url: ALLOCATE_POSITIONS(id),
    __typename: 'LegacyAPI',
    body: payload,
  };
};
